<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    Scratch Pad
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <div class="label-value-row">
    <span class="label">Weighted Average:</span>
    <span class="value">{{weightedAverage}}</span>
    <button (click)="openAddForm()" data-testid="btnAddDailyDosing" mat-raised-button color="primary">
      Add Daily
      Dosing
    </button>
  </div>
  <div class="gridheight mat-elevation-z8 viewport">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openEditForm(row)">
              <mat-icon matListIcon>edit</mat-icon>
              <span matLine>Edit</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <ng-container *ngFor="let col of columns;" [matColumnDef]="col.key">
        <th mat-header-cell *matHeaderCellDef>
          {{ col.header }}
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container [ngSwitch]="col.type">
            <span *ngSwitchCase="'date'">{{ row[col.key] | date:'MM/dd/yyyy hh:mm a' }}</span>
            <span *ngSwitchCase="'number'">{{ row[col.key] }}</span>
            <span *ngSwitchDefault>{{ row[col.key] ?? '' }}</span>
          </ng-container>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length"
            style="color: red;text-align: center;font-weight: 500;">
          No Data Found
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>


